import { Controller } from "@hotwired/stimulus"

// This controller is used to handle message editor in inbox
export default class extends Controller {
  static get targets() {
    return ["bodyInput", "submitButton"]
  }

  bodyUpdate() {
    this.submitButtonTarget.disabled = this.bodyInputTarget.value.length === 0
  }
}
